module.exports = __webpack_public_path__ + "img/code.f2377f62.png";